import {
  bool, func, shape, string,
} from 'prop-types'
import React, { PureComponent } from 'react'
import { merge } from '../../shared/utils/commonUtils'
import CoppaEmailInput from '../common/CoppaEmailInput'
import DefaultComponentLayout, { ErrorContent, LayoutContent } from '../common/Layout'
import CountryChoose from '../Signin/components/CountryChoose'
import GrantPermission from '../Signin/components/GrantPermission'
import ReagreeWaiver from '../Signin/components/ReagreeWaiver'
import ReagreeWaiverConfirm from '../Signin/components/ReagreeWaiverConfirm'

class SilentSignin extends PureComponent {
  static propTypes = {
    services: shape({
      b2cResignin: func.isRequired,
    }).isRequired,
    configureTrack: func.isRequired,
    isGrantPermissionShow: bool,
    clientName: string,
    countryCodes: string.isRequired,
    clientConfig: shape({
      suppressActiveWaiver: bool,
      useCustomizeWaiver: bool,
      waiverAttachementObjectIds: string,
    }).isRequired,
    Header: func,
  }

  static defaultProps = {
    isGrantPermissionShow: false,
    clientName: '',
    Header: null,
  }

  constructor(props) {
    super(props)

    const { isGrantPermissionShow, clientName } = props

    this.state = {
      accountCountryCode: '',
      isCountryChooseShow: false,
      isReagreeWaiverShow: false,
      isReagreeWaiverConfirmShow: false,
      isCoppaEmailInputShow: false,
      isBack: false,
      resetAgrees: false,
      isGrantPermissionShow,
      clientName,
      pendingKey: '',
    }
  }

  componentDidMount() {
    this.handleSubmit({})
  }

  componentWillUnmount() {
    if (this.countryChooseTimer) {
      clearTimeout(this.countryChooseTimer)
    }
    if (this.reagreeWaiverTimer) {
      clearTimeout(this.reagreeWaiverTimer)
    }
    if (this.reagreeWaiverConfirmTimer) {
      clearTimeout(this.reagreeWaiverConfirmTimer)
    }
  }

  handleSubmit = values => {
    // values has selectedCountryCode, isCountryChooseSubmit, reagree, 'permissions[]': 'PROFILE'

    const {
      services,
      countryCodes,
      clientConfig: {
        suppressActiveWaiver,
        useCustomizeWaiver,
        waiverAttachementObjectIds,
      },

      configureTrack,
    } = this.props
    let nextState = {}

    const params = {
      countriesInfo: countryCodes,
      suppressActiveWaiver,
      useCustomizeWaiver,
      waiverAttachementObjectIds,
      ...values,
    }

    services.b2cResignin({
      headers: {
        Accept: 'application/json',
      },
      params,
      resolve: ({
        status, loginURL, message, pendingKey, accountCountryCode, clientName,
      }) => {
        this.closeModals()
        if (status === 'SUCCESS'
          // Ignore PSW_NOT_QUALFIED due to it is a third party and password isnot the identity code
          || status === 'PSW_NOT_QUALFIED') {
          configureTrack({
            eventName: 'SignInConfirmation',
            widget: 'signin',
            pageType: 'sign in',
            explicitName: 'sign in confirmation',
            eventTracking: 'active connect',
          })
          window.location.href = loginURL
        } else if (status === 'NO_COUNTRY_CODE') {
          this.setState({
            isCountryChooseShow: true,
            accountCountryCode: '',
          })
        } else if (status === 'WAIVER_EXPIRED') {
          this.setState({
            isBack: !!values.isCountryChooseSubmit,
            resetAgrees: true,
            isReagreeWaiverShow: true,
            accountCountryCode: accountCountryCode,
          })
        } else if (status === 'COPPA') {
          this.setState({
            isCoppaEmailInputShow: true,
            pendingKey,
          })
        } else if (status === 'NEED_PERMISSION') {
          this.setState({
            isGrantPermissionShow: true,
            clientName,
          })
        } else if (status === 'PERMISSION_FAIL') {
          nextState = merge(nextState, {
            errorMsg: 'passport.permission.granting.fail',
            showError: true,
            fields: { pawd: '' },
          })
          configureTrack({
            eventName: 'SignInError',
            widget: 'signin',
            pageType: 'sign in',
            explicitName: 'sign in error PERMISSION_FAIL',
          })
        } else {
          Object.assign(nextState, {
            errorMsg: message,
            showError: true,
          })
          configureTrack({
            eventName: 'SignInError',
            widget: 'signin',
            pageType: 'sign in',
            explicitName: 'sign in error',
          })
        }
      },
      reject: ({ message }) => {
        this.closeModals()
        nextState = merge(nextState, {
          errorMsg: message,
          showError: true,
        })
      },
      complete: () => {
        this.setState(nextState)
      },
    })
  }

  /** modal start */
  /** countryChoose start */
  handleChangeCountry = value => {
    this.setState({
      selectedCountryCode: value,
    })
  }

  handleCountryChooseModalClose = () => {
    this.setState({
      isCountryChooseShow: false,
    })
  }

  handleCountryChooseSubmit = () => {
    const { selectedCountryCode } = this.state
    this.handleSubmit({
      selectedCountryCode,
      isCountryChooseSubmit: true,
    })
  }
  /** countryChoose end */

  /** ReagreeWaiver  start */
  handleReagreeWaiverClose = () => {
    this.setState({
      isReagreeWaiverShow: false,
    }, () => {
      this.reagreeWaiverConfirmTimer = setTimeout(() => {
        this.setState({
          isReagreeWaiverConfirmShow: true,
        })
      }, 500)
    })
  }

  handleReagreeWaiverSubmit = () => {
    this.handleSubmit({
      reagree: true,
    })
  }

  handleBack = () => {
    this.setState({
      isReagreeWaiverShow: false,
    }, () => {
      this.countryChooseTimer = setTimeout(() => {
        this.setState({
          isCountryChooseShow: true,
        })
      }, 500)
    })
  }

  handleReagreeWaiverCheckboxChange = () => {
    this.setState({
      resetAgrees: false,
    })
  }
  /** ReagreeWaiver  end */

  /** ReagreeWaiverConfirm  start */
  handleReagreeWaiverConfirmClose = () => {
    this.setState({
      resetAgrees: true,
      isReagreeWaiverConfirmShow: false,
    })
  }

  handleCancel = () => {
    this.setState({
      isReagreeWaiverConfirmShow: false,
    }, () => {
      this.reagreeWaiverTimer = setTimeout(() => {
        this.setState({
          isReagreeWaiverShow: true,
        })
      }, 500)
    })
  }

  /** ReagreeWaiverConfirm  end */

  /** GrantPermission start */

  handleGrantPermissionClose = () => {
    this.setState({
      isGrantPermissionShow: false,
    })
  }

  handleGrantPermissionSubmit = params => {
    if (params.buttonId === 'allow') {
      this.handleSubmit({
        'permissions[]': 'PROFILE',
      })
    } else {
      this.handleGrantPermissionClose()
    }
  }

  /** GrantPermission end */

  closeModals = () => {
    this.setState({
      isCountryChooseShow: false,
      isGrantPermissionShow: false,
      isReagreeWaiverShow: false,
      isReagreeWaiverConfirmShow: false,
      isCoppaEmailInputShow: false,
    })
  }

  /** modal end  */

  render() {
    const {
      Header, services, ...rest
    } = this.props
    const {
      errorMsg, showError,
      isBack,
      accountCountryCode,
      isCountryChooseShow,
      isReagreeWaiverShow,
      isReagreeWaiverConfirmShow,
      resetAgrees,
      isGrantPermissionShow,
      isCoppaEmailInputShow,
      pendingKey,
      clientName,
    } = this.state

    if (isCoppaEmailInputShow) {
      return (
        <CoppaEmailInput Header={Header} pendingKey={pendingKey} services={services} />
      )
    }

    return (
      <DefaultComponentLayout nameSpace="passport__signin">
        <LayoutContent main>
          <div>
            <CountryChoose
              isCountryChooseShow={isCountryChooseShow}
              handleChangeCountry={this.handleChangeCountry}
              handleCountryChooseModalClose={this.handleCountryChooseModalClose}
              handleCountryChooseSubmit={this.handleCountryChooseSubmit}
            />
            <ReagreeWaiver
              isBack={isBack}
              selectedCountryCode={accountCountryCode}
              isReagreeWaiverShow={isReagreeWaiverShow}
              handleReagreeWaiverClose={this.handleReagreeWaiverClose}
              handleReagreeWaiverSubmit={this.handleReagreeWaiverSubmit}
              handleBack={this.handleBack}
              resetAgrees={resetAgrees}
              handleReagreeWaiverCheckboxChange={this.handleReagreeWaiverCheckboxChange}
              {...rest}
            />
            <ReagreeWaiverConfirm
              handleReagreeWaiverConfirmClose={this.handleReagreeWaiverConfirmClose}
              isReagreeWaiverConfirmShow={isReagreeWaiverConfirmShow}
              handleCancel={this.handleCancel}
              errorMsg={errorMsg}
            />
            <GrantPermission
              handleGrantPermissionClose={this.handleGrantPermissionClose}
              handleGrantPermissionSubmit={this.handleGrantPermissionSubmit}
              {...rest}
              clientName={clientName}
              isGrantPermissionShow={isGrantPermissionShow}
            />
            {showError && <ErrorContent errorMsg={errorMsg} />}
          </div>
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default SilentSignin
